import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";

import Breadcrumbs from "components/Common/BreadcrumbTitle";

import { editRole, getOneRole } from "../../http/fundLync/role.helper";

import { useToast } from "ToastStore";
import { decryptedValue } from "common/utility";

const UpdateRole = (props) => {
  document.title = "Update Role | FundLync";
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const [roleList, setRoleList] = useState({});
  const user = decryptedValue(localStorage.getItem("user"));

  const { handleToastData } = useToast();
  useEffect(() => {
    getOneRole({ roleId: decodedId })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data);
        }
      })
      .catch(error => { })
  }, []);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      roleName: roleList.roleName || "",
      roleDescription: roleList.roleDescription || "",
      displayName: roleList.displayName || "",
      entityType: roleList.entityType || "",
    },
    validationSchema: Yup.object({
      roleName: Yup.string().required("Please Enter Permission Name"),
      roleDescription: Yup.string().required("Please Enter Role Description"),
      displayName: Yup.string().required("Please Enter Role Display Name"),
      entityType: Yup.string().required("Please Select Entity Type"),
    }),
    onSubmit: (values) => {
      const updateRole = {
        id: decodedId,
        roleName: values.roleName,
        roleDescription: values.roleDescription,
        displayName: values.displayName,
        entityType: values.entityType,
      };

      editRole(updateRole)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            handleToastData(responseFromAPI.message, "success")
            navigate(`/${user.roleName}/roles`)
          }
        })
        .catch(error => { })
      validation.resetForm();
    }
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="UPDATE ROLE" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col md="6" sm="12">
                      <Label className="form-label mt-2">Role Name*</Label>
                      <Input
                        name="roleName"
                        type="text"
                        placeholder="Insert Role Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.roleName || ""}
                        invalid={
                          validation.touched.roleName &&
                          validation.errors.roleName
                        }
                      />
                      {validation.touched.roleName &&
                        validation.errors.roleName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.roleName}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col md="6" sm="12">
                      <Label className="form-label mt-2">
                        Role Description*
                      </Label>
                      <Input
                        name="roleDescription"
                        type="text"
                        placeholder="Insert Role Description"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.roleDescription || ""}
                        invalid={
                          validation.touched.roleDescription &&
                          validation.errors.roleDescription
                        }
                      />
                      {validation.touched.roleDescription &&
                        validation.errors.roleDescription ? (
                        <FormFeedback type="invalid">
                          {validation.errors.roleDescription}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md="6" sm="12">
                      <Label className="form-label mt-2">
                        Role Display Name*
                      </Label>
                      <Input
                        name="displayName"
                        type="text"
                        placeholder="Insert Role Display Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.displayName || ""}
                        invalid={
                          validation.touched.displayName &&
                          validation.errors.displayName
                        }
                      />
                      {validation.touched.displayName &&
                        validation.errors.displayName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.displayName}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md="6" sm="12">
                      <Label className="form-label mt-2">Entity Type*</Label>
                      <Input
                        name="entityType"
                        type="select"
                        placeholder="Select Entity Type"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.entityType || ""}
                        invalid={
                          validation.touched.entityType &&
                          validation.errors.entityType
                        }
                      >
                        <option value="" disabled>Select Entity Type</option>
                        <option value="Owner">Owner</option>
                        <option value="Customer">Customer</option>
                        <option value="Financier">Financier</option>
                      </Input>
                      {validation.touched.entityType &&
                        validation.errors.entityType ? (
                        <FormFeedback type="invalid">
                          {validation.errors.entityType}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-4">
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-outline-success save-customer me-3"
                          onClick={() => navigate(-1)}
                        >
                          Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-customer"
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpdateRole;

UpdateRole.propTypes = {
  history: PropTypes.object,
};
